import React from 'react';
import NumberFormat from 'react-number-format';

function ParseNumberSmaller({ field, className }: any) {
    return (
        <NumberFormat {...field} thousandSeparator={true} className={className || 'form-know-you-item-input-smaller display-flex'} decimalScale={0} allowNegative={false}/>
    )
}

export default ParseNumberSmaller;